import React from "react";
import './ContactMeCard.css';

const ContactMeCard = ({ iconURL, text, href }) => {
  const Tag = href ? "a" : "div";
  const linkProps = href
    ? { href, target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <Tag className="contact-details-card" {...linkProps}>
      <div className="icon">
        <img src={iconURL} alt={text} />
      </div>
      <p>{text}</p>
    </Tag>
  );
};

export default ContactMeCard;